import { type DataProvider as RaDataProvider, fetchUtils } from 'react-admin'
import simpleRestProvider from 'ra-data-simple-rest'
import jsonProvider from 'ra-data-fakerest'

import { url } from './functions'
// import { isNil } from 'lodash/fp'

const fetchJson = (url: string, options: fetchUtils.Options = {}): any => {
  // const customHeaders = getCustomHeaders(options)
  // if (isNil(customHeaders)) return undefined
  // options.headers = customHeaders
  return fetchUtils.fetchJson(url, options)
}

export const DataProvider = (): RaDataProvider =>
  'TEST' in process.env
    ? {
      ...jsonProvider({
        data: {}
      })
    }
    : {
      ...simpleRestProvider(url, fetchJson)
    }
